import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../auth/user.service';
import { AdminService } from '../../admin.service';
import { CommonUtil } from '../../../shared/services/utility/common.service';
import { BreadcrumbService } from '../../../shared/breadcrumb/breadcrumb.service';
import { NotificationMessageService } from '../../../shared/notification-message/notification-message.service';

@Component({
  selector: 'app-oem',
  templateUrl: './oem.component.html',
  styleUrls: ['./oem.component.css']
})
export class OemComponent implements OnInit, OnDestroy {

	OEMs = <any>[];

	currentUser = {};

	constructor(
		private adminService: AdminService,
		private commonUtil: CommonUtil,
		public userService: UserService,
		private breadcrumb: BreadcrumbService,
		private notificationMessage: NotificationMessageService
	) {
	}

	ngOnInit() {
		this.breadcrumb.setBreadcrumb([{'label': 'OEMs', 'url': ''}]);
		this.currentUser = this.userService.getCurrentUser();
		this.getOEMs();
	}

	getOEMs(id = 0) {
		this.adminService.getOEMs(id).subscribe(
			data => {
				this.OEMs = data;
			}
		);
	}

	deleteOEM(id, confirmed) {

		let msg = "Are you sure you want to delete this OEM?";
		
		if(confirmed || confirm(msg)) {
			this.adminService.deleteDealerOrOEM(id, 'oem', confirmed).subscribe(
				response => {
					if(response['httpStatus'] == 'error') {
						let res = response['error'];
						if(res['msg'] == 'has devices') {

							let pronoun = res['data'] > 1 ? 'them' : 'it';

							let confMsg = "This OEM have " + this.commonUtil.singularOrPlural(res['data'], "device") + ". This action will assign " + pronoun + " to NO OEM!";

							if(confirm(confMsg)) {
								this.deleteOEM(id, true);
							}
						} else {
							let errMsg: string = '';
							if(res['msg'] == 'own sites') {
								let sites = this.commonUtil.extractKeyFromObjects('name', res['data']).join('<br/>');
								errMsg = "This OEM owns the following " + this.commonUtil.singularOrPlural(res['data'].length, "site", false) + ":<br/>" + sites;
							} else if(res['msg'] == 'has users') {
								
								errMsg = "This OEM have some users. Please delete them before doing this action!";
							}
							this.notificationMessage.setMessage(errMsg, 'danger', 30000);
						}
					} else {
						this.getOEMs(0);
					}
				}
			);
		}
	}
	
	ngOnDestroy() {
		this.breadcrumb.hide();
	}
}
